import styledC from 'styled-components';

import { VirtualizedMenuItemProps } from './VirtualizedMenuItem';
import MenuGroupHeader from '../../layout/Menu/MenuGroupHeader';

const VirtualizedMenuGroupHeader = styledC(
  MenuGroupHeader,
).attrs<VirtualizedMenuItemProps>((props) => ({
  style: {
    transform: `translateY(${props.start}px)`,
    height: `${props.height}px`,
  },
}))<VirtualizedMenuItemProps>`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
`;

VirtualizedMenuGroupHeader.displayName = 'VirtualizedMenuGroupHeader';

export default VirtualizedMenuGroupHeader;
